module.exports = __webpack_public_path__ + "intern.1yQ4zC2e.svg";